import { injectable, postConstruct } from 'inversify'
import { IComment } from '@/model/comment'
import { MetaService, MetaServiceImpl } from './MetaService'

export interface CommentService extends MetaService<IComment> {
}

@injectable()
export class CommentServiceImpl extends MetaServiceImpl<IComment> {
  @postConstruct()
  public initialize () {
    this.serviceName = 'comments'
  }
}
